@if (sale().unitId) {
<div class="property-list-item" (click)="selectSale(sale())" [ngClass]="{ 'is-for-sale': sale().isForSale, 'is-judicial-transfer': sale().isJudicialTransfer }">
    <div class="icon" [class]="'property-' + sale().estateTypeCssString"></div>
    <div class="item-data-wrapper">
        <div class="first-row">
            <div class="address">
                @if (sale().address?.streetAddress) {
                <span>{{ sale().address.streetAddress | dash }}</span>
                }@else{
                <span>{{ sale().cadastre | dash }}</span>
                } @if (sale().address?.postOffice?.code || sale().address?.postOffice?.name) {
                <span>, {{ sale().address?.postOffice?.code | dash }} {{ sale().address?.postOffice?.name | dash }}</span>
                }
            </div>
        </div>
        <div class="second-row">
            @if (sale().judicialTransferDate) {
            <div class="date">{{ sale().judicialTransferDate | date : "dd.MM.yyyy" | dash }}</div>
            }@else{
            <div class="date">{{ sale().informationDate | date : "dd.MM.yyyy" | dash }}</div>
            } @if (sale().residentialMeasuredArea){
            <div class="area">{{ sale().residentialMeasuredArea | dash | areaconverter }}</div>
            } @else {
            <div class="area">{{ (sale().grossArea && sale().grossArea !== 0 ? sale().grossArea : sale().usableArea) | dash | areaconverter }}</div>
            } @if (sale().salesPrice) {
            <div class="price">{{ sale().salesPrice | number : "1.0-0" | dash }}</div>
            } @else {
            <div class="price">{{ sale().askingPrice | number : "1.0-0" | dash }}</div>
            }
        </div>
    </div>
</div>
}
